import { render, staticRenderFns } from "./DisplayForCockpit.vue?vue&type=template&id=38590f64&lang=pug&"
import script from "./DisplayForCockpit.vue?vue&type=script&lang=ts&"
export * from "./DisplayForCockpit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports